import React from 'react'
import getPermission from '@fs/zion-permissions'

export default function useIsAuthorized() {
  const [isAuthorized, setAuthorized] = React.useState(false)
  React.useEffect(() => {
    ;(async () => {
      const helperPermission = getPermission('CISHelperPermission', 'CISHelperContext')
      // Used to detect if user is not in Russia and is not a Russia citizen.
      const nonRussiaPermission = getPermission('CanAddPersonalDataPermission', 'FamilyTree')
      await Promise.all([helperPermission, nonRussiaPermission]).then(
        ([{ authorized: authorizedHelper }, { authorized: notRussia }]) => {
          setAuthorized(authorizedHelper && notRussia)
        }
      )
    })()
  }, [])
  return isAuthorized
}
